import React, { useEffect, useState } from "react"

import "./QueuedPatients.css"
import "../../Components/Commons/Commons.css"

import DeleteModal from "../../Components/Modals/DeleteModal"
import ViewPending from "./ViewPending"
import SidebarMenu from "../../Components/Sidebar/Sidebar"
import { useNavigate } from "react-router-dom"
import {
  capitalizeFirstLetter,
  formatToTimeOnly,
  getRole,
  refreshPage,
} from "../../Components/Helpers/Utilities/Common"
import {
  getQueuedPatients,
  removePatientFromQueue,
  updateQueue,
} from "../../Components/Helpers/API/QueueApi/QueueApi"
import { toast } from "react-toastify"

import { Tag, Table, Button, Row, Col, Select, Space, Input } from "antd"
import EditQueueModal from "../../Components/Modals/EditQueueModal"
import { getAllDoctors } from "../../Components/Helpers/API/DoctorApi/DoctorApi"
const { Search } = Input

function QueuedPatients() {
  const role = getRole()
  const navigate = useNavigate()
  const [isClicked, setIsClicked] = useState(false)
  const [showDelete, setShowDelete] = useState(false)
  const [showLoader, setShowLoader] = useState(false)
  const [selectedRow, setSelectedRow] = useState("")
  const [data, setData] = useState([])
  const [selectedDoctor, setSelectedDoctor] = useState(null)
  const [doctors, setDoctors] = useState([])
  const [complaint, setComplaint] = useState("")
  const [showViewPendingModal, setShowViewPendingModal] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [filterConfig, setFilterConfig] = useState({
    doctor_id: "",
    assessment_status: "",
  })

  // Function for action buttons in table
  function ActionBtn(row) {
    return (
      <>
        <Row className="center mb-2">
          <Space>
            {getRole() !== "nurse" && (
              <>
                <Button
                  className="primary-btn"
                  onClick={() => {
                    navigate("/patients/profile/" + row.row.patient_id, {
                      state: {
                        complaint: row.row.chief_complaint || "",
                        fromQueueCheckUp: true,
                      },
                    })
                    localStorage.setItem("isCheck", JSON.stringify(true))
                    localStorage.setItem("isTrue", JSON.stringify(false))
                    localStorage.setItem(
                      "vitalSignLab",
                      JSON.stringify("medical_history")
                    )
                    localStorage.setItem(
                      "medicalHistory",
                      JSON.stringify("")
                    )
                  }}
                >
                  Check-Up
                </Button>
              </>
            )}
            <Button
              className="primary-btn"
              onClick={() =>
                navigate("/patients/profile/" + row.row.patient_id)
              }
            >
              View
            </Button>
          </Space>
        </Row>
        {getRole() !== "nurse" && (
          <>
            <Row className="center mb-2">
              <Space>
                <Button
                  className="primary-btn"
                  // onClick={() => navigate("/patients/profile/" + row.row.patient_id)}
                  onClick={() => {
                    setSelectedRow(row.row)
                    // setSelectedDoctor(row?.row?.doctor_id);
                    setComplaint(row?.row?.complaint)
                    setShowEditModal(true)
                  }}
                >
                  Edit Queue Details
                </Button>
              </Space>
            </Row>
          </>
        )}
        <Row className="center">
          <Space>
            <Button
              className="delete-btn"
              onClick={() => {
                setSelectedRow(row.row)
                setShowDelete(true)
              }}
            >
              Remove from Queue
            </Button>
          </Space>
        </Row>
      </>
    )
  }

  // Function for changing design of data inside table
  function StatusTag({ status }) {
    if (status.assessment_status === "pending_payment") {
      return (
        <Tag
          color="orange"
          className="status-queue"
          onClick={() => {
            setSelectedRow(status)
            setShowViewPendingModal(true)
          }}
        >
          Review Payment
        </Tag>
      )
    } else {
      return (
        <Tag className="status-queue" style={{ textTransform: "capitalize" }}>
          {status.assessment_status}
        </Tag>
      )
    }
  }

  function PatientStatusTag({ status }) {
    if (status === "ongoing") {
      return <Tag color="red">Ongoing</Tag>
    } else if (status === "pending") {
      return <Tag color="orange">Pending</Tag>
    } else if (status === "for_labs") {
      return <Tag color="yellow">For Labs</Tag>
    } else {
      return <Tag>{status}</Tag>
    }
  }

  function TypeTag({ type }) {
    if (type === "admit") {
      return <Tag color="cyan">Admit</Tag>
    } else if (type === "outpatient") {
      return <Tag color="blue">Outpatient</Tag>
    } else if (type === "for_admission") {
      return <Tag color="orange">For Admission</Tag>
    } else if (type === "eKonsulta") {
      return <Tag color="cyan">eKonsulta</Tag>
    } else {
      return <Tag>{type}</Tag>
    }
  }

  const columns = [
    // {
    //   dataIndex: "corporate_type",
    //   key: "corporate_type",
    //   render: (_, record) => {
    //     const { corporate_type, hmo_type } = record;

    //     let backgroundColor = "transparent";

    //     if (hmo_type) {
    //       backgroundColor = "#273DE9"; // blue
    //     } else if (corporate_type) {
    //       backgroundColor =
    //         corporate_type?.toLowerCase() === "gmc-mg" ? "#fa8c16" : "#fadb14"; // orange or yellow
    //     }

    //     return {
    //       props: {
    //         style: {
    //           backgroundColor,
    //         },
    //       },
    //       children: "",
    //     };
    //   },
    // },
    // {
    //   title: "Coverage Name",
    //   dataIndex: "coverage_type",
    //   key: "coverage_type",
    //   align: "center",
    //   render: (_, record) => {
    //     const { hmo_type, corporate_type } = record;

    //     if (hmo_type) return hmo_type;
    //     if (corporate_type) return corporate_type;
    //     return "";
    //   },
    // },
    {
      title: "Queue #",
      dataIndex: "queue_number",
      key: "queue_number",
      align: "center",
    },
    // {
    //   title: 'Pending Payment',
    //   dataIndex: 'status',
    //   key: 'status',
    // },
    {
      title: "Name",
      dataIndex: "formatted_patient_name",
      key: "formatted_patient_name",
      align: "center",
    },
    {
      title: "Age",
      dataIndex: "age",
      key: "age",
      align: "center",
    },
    {
      title: "Gender",
      dataIndex: "formatted_patient_sex",
      key: "formatted_patient_sex",
      align: "center",
    },
    // {
    //   title: "Contact",
    //   dataIndex: "patient_phone_no",
    //   key: "patient_phone_no",
    //   align: "center",
    // },
    {
      title: "Chief Complaint",
      dataIndex: "chief_complaint",
      key: "chief_complaint",
      align: "center",
    },
    ...(role === "nurse"
      ? [
          {
            title: "Assigned To",
            dataIndex: "doctor_name",
            key: "doctor_name",
            align: "center",
          },
        ]
      : []),
    {
      title: "Assigned On",
      dataIndex: "formatted_added_on",
      key: "formatted_added_on",
      align: "center",
    },
    {
      title: "Type",
      dataIndex: "formatted_type",
      key: "formatted_type",
      align: "center",
    },
    {
      title: "Status",
      dataIndex: "formatted_assessment_status",
      key: "formatted_assessment_status",
      align: "center",
    },
    {
      dataIndex: "actions",
      key: "actions",
      width: "5vw",
      render: (_, record) => <ActionBtn row={record} />,
    },
  ]

  // Function for editing queue details
  const handleEdit = async () => {
    setIsClicked(true)
    const res = await updateQueue({
      queue_id: selectedRow?.id,
      patient_id: selectedRow?.patient_id,
      status: "",
      doctor_id: selectedDoctor !== null ? selectedDoctor : "",
      complaint: complaint?.toUpperCase(),
    })
    if (res.data) {
      toast.success(res.data.message)
      fetchQueuedPatients()
      setShowEditModal(false)
    } else if (res.error) {
      toast.error(res.error.data.messages.error_messages[0])
    }
    setIsClicked(false)
  }

  // Function for removing patient from queue
  async function removeFromQueue(patientId) {
    setIsClicked(true)
    const res = await removePatientFromQueue(patientId)
    if (res.data) {
      toast.success(res.data.message)
      setShowDelete(false)
      if (data.length === 1) {
        refreshPage()
      } else {
        fetchQueuedPatients()
      }
    } else if (res.error) {
    }
    setIsClicked(false)
  }

  // Function for get all doctors API
  async function fetchAllDoctors() {
    const response = await getAllDoctors()
    if (response.data) {
      const mappedDoctors = response.data.data.map((doctor) => ({
        label: doctor.doctor_name,
        value: doctor.id,
        id: doctor.id,
        doctor_name: doctor.doctor_name,
      }))
      setDoctors(mappedDoctors)
    } else {
      setDoctors([])
    }
  }

  // Get all queued patient
  async function fetchQueuedPatients() {
    setShowLoader(true)
    const res = await getQueuedPatients({
      status: "queued",
      doctor_id: filterConfig.doctor_id,
      assessment_status: filterConfig.assessment_status,
      search: filterConfig?.search || "",
      is_phic_member: 1,
    })

    if (res.data) {
      var _parsed = (res.data.data ?? []).map((assessment) => {
        let type = assessment.phic_membership_type
          ? "eKonsulta"
          : assessment.type
        return {
          ...assessment,
          formatted_patient_sex: capitalizeFirstLetter(assessment.patient_sex),
          formatted_added_on: formatToTimeOnly(assessment.added_on),
          status: <StatusTag status={assessment} />,
          formatted_type: <TypeTag type={type} />,
          formatted_assessment_status: (
            <PatientStatusTag status={assessment.assessment_status} />
          ),
        }
      })
      setData(_parsed)
    } else if (res.error) {
      setData([])
    }
    setShowLoader(false)
  }

  const handleChange = (e) => {
    setFilterConfig((prev) => ({
      ...prev,
      search: e || "",
    }))
  }

  const handleEmpty = (e) => {
    if (e.target.value === "") {
      setFilterConfig((prev) => ({
        ...prev,
        search: e.target.value || "",
      }))
    }
  }

  useEffect(() => {
    fetchAllDoctors()
  }, [])

  useEffect(() => {
    fetchQueuedPatients()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterConfig])

  return (
    <div className="App">
      <SidebarMenu active={"Queued Patients"} />
      <div className="col p-5 pt-4 scrollable-container">
        <div className="row pt-2 p-3">
          <div className="col font-big title-2 all-patient">
            QUEUED PATIENTS COUNT : {data?.length || "0"}
          </div>
        </div>
        <Row className="mb-2">
          {/* {role === "nurse" && (
            <>
              <Col lg={6}>
                <Select
                  placeholder="Select Doctor"
                  style={{ width: "100%" }}
                  allowClear
                  options={doctors}
                  optionFilterProp="label"
                  showSearch
                  onChange={(value) =>
                    setFilterConfig((prev) => ({
                      ...prev,
                      doctor_id: value,
                    }))
                  }
                />
              </Col>
            </>
          )} */}
          <Col lg={3} className="ms-lg-2">
            <Select
              placeholder="Select Status"
              style={{ width: "100%" }}
              allowClear
              showSearch
              optionFilterProp="label"
              value={filterConfig?.assessment_status}
              options={[
                { label: "All Status", value: "" },
                { label: "Pending", value: "pending" },
                { label: "For Labs", value: "for_labs" },
                { label: "Ongoing", value: "ongoing" },
              ]}
              onChange={(value) =>
                setFilterConfig((prev) => ({
                  ...prev,
                  assessment_status: value || "",
                }))
              }
            />
          </Col>
          <Col lg={6} style={{ marginLeft: "auto" }}>
            <Search
              placeholder="Search Patient..."
              size="medium"
              onSearch={(e) => handleChange(e)}
              onChange={(e) => handleEmpty(e)}
              className="responsive-header-input"
            />
          </Col>
        </Row>
        <div className="row justify-content-center">
          <div className="col-sm-12 all-table">
            <Table
              columns={columns}
              dataSource={data}
              loading={showLoader}
              pagination={false}
            />
          </div>
        </div>
      </div>
      <DeleteModal
        title="Do you want to remove this patient from the queue?"
        show={showDelete}
        onHide={() => setShowDelete(false)}
        onDelete={() => removeFromQueue(selectedRow.patient_id)}
        isClicked={isClicked}
      />

      <ViewPending
        show={showViewPendingModal}
        onHide={() => setShowViewPendingModal(false)}
        data={selectedRow}
        removeFromQueue={removeFromQueue}
      />

      <EditQueueModal
        patientId={selectedRow?.patient_id}
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        onChange={(e) => setComplaint(e.target.value)}
        queueDetails={selectedRow}
        complaint={complaint}
        doctorsData={doctors}
        selectedDoctor={selectedDoctor}
        setSelectedDoctor={setSelectedDoctor}
        onConfirm={handleEdit}
        isClicked={isClicked}
      />
    </div>
  )
}

export default QueuedPatients
